import React from 'react';
import { Button, ListGroup, ListGroupItem } from 'reactstrap';

const TroubleshootManager = ({troubleshoots,onEditTroubleshoot,onDelete,onEdit})=>{
    return(
        <React.Fragment>
            {troubleshoots.length > 0 ? (
                <ListGroup>
                    {troubleshoots.map(troubleshoot => (
                        <ListGroupItem 
                            key={troubleshoot.id}
                            tag="button"
                            action
                            className="float-action-list-item"
                            >
                            <div className="float-action-content">
                                <span>{troubleshoot.activity_name}</span>
                                <div className="float-action-buttons">
                                    <Button 
                                        size="sm" 
                                        color="warning" 
                                        outline
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            onEdit({
                                                ...troubleshoot,
                                                name:troubleshoot?.activity_name,
                                                listgroup:'Troubleshoot'});
                                        }}
                                    >
                                        <span className='ri-pencil-fill'></span>
                                    </Button>
                                    <Button 
                                        size="sm" 
                                        color="danger" 
                                        outline
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            onDelete({
                                                ...troubleshoot,
                                                name:troubleshoot?.activity_name,
                                                listgroup:'Troubleshoot'});
                                        }}
                                    >
                                        <span className='ri-delete-bin-line'></span>
                                    </Button>
                                </div>
                            </div>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            ) : (
                <p>No troubleshoot activities available.</p>
            )}
        </React.Fragment>
    )
}

export default TroubleshootManager;